import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HeroSection() {
  const { t } = useTranslation("home");

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20luxurious%20flowing%20gown%20walking%20confidently%20on%20city%20street%20at%20golden%20hour%2C%20warm%20sunlight%20streaming%20through%20buildings%2C%20soft%20dreamy%20bokeh%20effect%2C%20editorial%20fashion%20photography%2C%20sophisticated%20and%20glamorous%20aesthetic%2C%20cream%20and%20gold%20color%20palette&width=1800&height=900&seq=hero-glamour-main&orientation=landscape"
          alt="华丽的外出 - 每一次出门都是时尚宣言"
          className="w-full h-full object-cover object-top"
          title="华丽的外出 - 华丽穿搭风格"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center max-w-3xl">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 mb-4 md:mb-6 leading-tight tracking-wide">
            {t("heroTitle")}
          </h1>
          <p className="text-sm md:text-lg text-background-100/90 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
            {t("heroSubtitle")}
          </p>
          <Link
            to="/category/chuanda-gonglue"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 md:px-8 py-3 md:py-3.5 rounded-md text-sm md:text-base font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            {t("heroCTA")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}